// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"415":"d63de621","480":"577673eb","606":"f2cb5ac2","838":"db6bd5ee"}[chunkId] + ".js";
};